import { render, staticRenderFns } from "./BookingRunningNowBanner.vue?vue&type=template&id=61d9da26"
import script from "./BookingRunningNowBanner.vue?vue&type=script&lang=js"
export * from "./BookingRunningNowBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports